/**
 * THE TOUCH SURFACE — the labels on the pad (`mobile.md`).
 *
 * Short on purpose: a phone in landscape has no room for a sentence, and these sit on buttons a thumb
 * covers. What a control DOES is explained by the keyboard board on a desktop; here it has to be read at a
 * glance and in one word.
 */
export default {
  no_fullscreen: 'this browser will not go full screen',
  tilt_insecure: 'tilt unavailable — this page is not a secure context; it needs https',
  tilt_unsupported: 'tilt unavailable — this browser does not expose the accelerometer',
  tilt_on: 'tilt on — ±{deg}° over the drag',
  tilt_off: 'tilt off',
  tilt_no_events: 'no tilt — the browser does not deliver `devicemotion` on this page',
  tilt_no_accel: 'no tilt — events arrive but this device reports no accelerometer',
  tilt_refused: 'no tilt — {n} readings refused: they do not measure gravity (hold the phone still)',
  tilt_denied: 'tilt refused — the system did not grant motion permission',
  // The badge on the TILT button itself, which has room for two words and no more. Each names WHICH of
  // the four things is missing, because they are fixed in four different places: the page's scheme, the
  // hardware, a permission dialog and the sensor actually reporting.
  tilt_no_https: 'no HTTPS',
  tilt_no_sensor: 'no sensor',
  tilt_no_permission: 'no permission',
  tilt_no_reading: 'no reading',
  no_lock: 'this browser cannot pin the orientation — turn the phone',
  not_locked: 'orientation not pinned — turn the phone',
  // THE ROTATE NOTICE, which is the one piece of copy that has to be legible while the page is UNPLAYABLE:
  // it covers the field in portrait, so it names the gesture and the reason in two lines.
  rotate: 'TURN THE PHONE',
  rotate_sub: 'ARENA is played in landscape',
  fullscreen: 'full screen',
  stand: 'STAND',
  kneel: 'KNEEL',
  prone: 'PRONE',
  jump: 'JUMP',
  climb: 'CLIMB',
  third: 'THIRD',
  stealth: 'STEALTH',
  hands: 'HANDS',
  kit: 'KIT',
  pack: 'PACK',
  tilt: 'TILT',
};
